var _style, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgExportar01 = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 55",
    style: {
      enableBackground: "new 0 0 55 55"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5FB0B7;}\n\t.st1{fill:none;stroke:#5FB0B7;stroke-width:0.25;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40,25.3c-1.2,0-2.2,1-2.2,2.2v17.8c0,0.4-0.4,0.8-0.8,0.8H9.5c-0.4,0-0.8-0.4-0.8-0.8V17.7 c0-0.4,0.4-0.8,0.8-0.8h17.8c1.2,0,2.2-1,2.2-2.2s-1-2.2-2.2-2.2H9.5c-2.8,0-5.1,2.3-5.1,5.1v27.5c0,2.8,2.3,5.1,5.1,5.1h27.5 c2.8,0,5.1-2.3,5.1-5.1V27.4C42.2,26.2,41.2,25.3,40,25.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.2,4.7L36.4,7.6c-2,0.5-2.7,3.1-1.2,4.6l1.2,1.2c0.2,0.2,0.2,0.6,0,0.8L21.1,29.4c-1.3,1.3-1.3,3.5,0,4.8 c1.3,1.3,3.5,1.3,4.8,0l15.2-15.2c0.2-0.2,0.6-0.2,0.8,0l1.2,1.2c1.5,1.5,4,0.8,4.6-1.2l2.9-10.8C51.1,6,49.2,4.2,47.2,4.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.2,4.7L36.4,7.6c-2,0.5-2.7,3.1-1.2,4.6l1.2,1.2c0.2,0.2,0.2,0.6,0,0.8L21.1,29.4c-1.3,1.3-1.3,3.5,0,4.8 c1.3,1.3,3.5,1.3,4.8,0l15.2-15.2c0.2-0.2,0.6-0.2,0.8,0l1.2,1.2c1.5,1.5,4,0.8,4.6-1.2l2.9-10.8C51.1,6,49.2,4.2,47.2,4.7z"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExportar01, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Exportar-01.bdd78d6e.svg";
export { ForwardRef as ReactComponent };